import { client } from '../client';

export const deleteAvatar = async (user_id: number): Promise<void> => {
  await client.delete(`/users/${user_id}/avatar`);
};
